import axiosInstance from '../axiosConfig';

export default {
  async sendEmail(payload) {
    const response = await axiosInstance.post('RetailMailConfirma', payload);
    return response.data;
  },
  async validateToken(payload) {
    const response = await axiosInstance.post('RetailMailToken', payload);
    return response.data;
  },
};
